"use strict";

exports.__esModule = true;
exports.default = void 0;
var _dndStylesSt = require("./dnd-styles.st.css");
var _default = exports.default = {
  item: _dndStylesSt.classes.item,
  itemPlaceholder: _dndStylesSt.classes.itemPlaceholder,
  itemPreview: _dndStylesSt.classes.itemPreview,
  list: _dndStylesSt.classes.list,
  gridItemPlaceholder: _dndStylesSt.classes.gridItemPlaceholder,
  isInitialPositionToDrop: _dndStylesSt.classes.isInitialPositionToDrop,
  gridItemPreview: _dndStylesSt.classes.gridItemPreview,
  withGridItemStrip: _dndStylesSt.classes.withGridItemStrip,
  withGridItemStripRight: _dndStylesSt.classes.withGridItemStripRight
};
//# sourceMappingURL=dnd-styles.js.map